import React, { useState } from "react";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
import { QRCodeSVG } from "qrcode.react";
const TITLE = "محول الروابط إلى رمز QR";
const DESCRIPTION =
  "مولد رمز QR فوري: حوّل أي رابط، نص، أو بيانات إلى رمز QR مجاناً خلال ثوانٍ! قابل للتخصيص (لون، حجم، شعار) مع دعم جميع أنواع الهواتف - مثالي للشركات، التسويق، والمشاركة السريعة.";
const KEYWORDS = "محول الروابط, QR كود, مولد رمز QR";
const OG_URL = "https://do-calculate.com/calculator/ar/qr-code/";
function QRCodeConverter() {
  const [link, setLink] = useState("");
  const [qrCode, setQRCode] = useState("");
  const [error, setError] = useState("");
  const handleGenerateQR = () => {
    try {
      if (link) setQRCode(link);
      else setError("الرجاء إدخال رابط صالح.");
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>تقوم هذه الأداة بتحويل الروابط إلى رموز QR.</p>
                <p>
                  حول روابطك إلى رموز QR بلمسة زر واحدة! تتيح لك هذه الأداة
                  تحويل أي رابط إلى رمز QR قابل للمسح الضوئي بسهولة وسرعة. ما
                  عليك سوى لصق الرابط في الحقل المخصص والنقر على "توليد".
                  الآن يمكنك مشاركة معلوماتك بطريقة أكثر تفاعلية وابتكارية.
                </p>
                <p>
                  اجعل محتواك أكثر سهولة في الوصول إليه! هل تريد تبسيط عملية
                  الوصول إلى موقعك الإلكتروني أو صفحتك على وسائل التواصل
                  الاجتماعي؟ استخدم أداة تحويل الروابط إلى رموز QR لدينا. بمجرد
                  مسح رمز QR باستخدام هاتفك الذكي، سيتم توجيه المستخدم مباشرة
                  إلى الرابط المحدد.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="rtl">
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="link">
                        أدخل الرابط
                      </label>
                      <input
                        id="link"
                        type="text"
                        value={link}
                        onChange={(e) => setLink(e.target.value)}
                        placeholder="أدخل الرابط هنا"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleGenerateQR}
                    >
                      توليد
                    </button>
                  </div>
                  <br />
                  {error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      خطأ: {error}
                    </p>
                  )}
                  {qrCode && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>النتيجة:</h4>
                      <QRCodeSVG value={qrCode} size={128} />
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">الأسئلة الشائعة</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>ما هو رمز QR؟</h2>{" "}
                  </u>
                  <p>
                    رمز QR هو نوع من الرموز الثنائية يمكن قراءته بسهولة بواسطة
                    الأجهزة الإلكترونية لربط المستخدمين بمواقع الويب أو
                    التطبيقات.
                  </p>
                  <hr />
                  <div>
                    <u>
                      <h2 style={{ fontSize: "16px" }}>
                        كيف يمكنني استخدام هذه الأداة؟
                      </h2>{" "}
                    </u>
                    <p>
                      ببساطة، أدخل الرابط الذي ترغب في تحويله إلى رمز QR في
                      الحقل المخصص، ثم اضغط على "توليد رمز QR".
                    </p>
                    <hr />
                  </div>
                  <div>
                    <u>
                      <h2 style={{ fontSize: "16px" }}>
                        ما هي استخدامات رموز QR؟
                      </h2>{" "}
                    </u>
                    <p>
                      تُستخدم رموز QR في مجالات متعددة مثل التسويق، الإعلانات،
                      وتوفير معلومات سريعة للمستخدمين.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default QRCodeConverter;
